export default __webpack_public_path__ + "static/Plots0052-0feca222a028a9af11e7779383ddca92.jpg";